import React from 'react';
import API from '../../config/config';

const UpdateSoftware = (props: any) => {


  return (props.data &&
    <div className="update-software-background">
      <div className="container-fluid updatecontainer-fluid" >
        <img className="update-software-img" src={API.baseUrl + props.data.icon.url} alt={API.baseUrl + props.data.icon.alternativeText}></img>
      </div>
      <div className="update-software-richtext">
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: props.data.description }} />;
        </div>
      </div>
    </div>
  );
};
export default UpdateSoftware;
